module.exports = __webpack_public_path__ + "static/media/solicitacoes.033c19e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/solicitacoes.svg
// module id = 526
// module chunks = 0